import { render, staticRenderFns } from "./FacturasDeCompra.vue?vue&type=template&id=726e6aff"
import script from "./FacturasDeCompra.vue?vue&type=script&lang=js"
export * from "./FacturasDeCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports